import { Component, OnInit } from '@angular/core';
import { ComponentFixture, TestBed } from '@angular/core/testing';


@Component({
  selector: 'app-epdasinfo',
  templateUrl: './epdasinfo.component.html',
  styleUrls: ['./epdasinfo.component.scss']
})
export class EpdasinfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
